import './Request.scss';

import { Component } from '../../components/Component';
import { FiSubHeaderService } from './../../components/FiSubHeader/FiSubHeaderService';
import { FiHubspotService } from '../../services/Hubspot';
import * as angular from 'angular';

@Component({
    controllerAs: 'vm',
    template: require('./Request.html'),
    bindings: {
    }
})
export class Request {
    static $inject = [
        'fiSubHeaderService',
        '$http',
        'fiHubspotService',
    ];

    cName: string;
    cLastname: string;
    cEmail: string;
    cPhone: string;
    cDescription: string;
    cConsultation: boolean;

    thanks: boolean = false;
    recaptchaToken: string;
    
    constructor(
        private fshs: FiSubHeaderService,
        private $http: angular.IHttpService,
        private hubspot: FiHubspotService,
    ) {
        /* */
    }

    $onInit() {
        this.fshs.subHeaderIsHidden = false;
    }

    sendOLD() {
        this.$http.post("https://www.fitit.lt/db/request.php", { 

            name: this.cName,
            surname: this.cLastname,
            email: this.cEmail,
            phone: this.cPhone,
            description: this.cDescription,
            consulation: this.cConsultation

        }, { headers: {'Content-Type': 'application/json'} })
            .then(function (response) {

                console.log(response);

                if(response.data == 'return') {
                    // alert('return');
                }
                else {
                    
                }
                return;

        });

        // this.thanks = true;
    }

    send() {
        this.hubspot.submit(this.recaptchaToken, 'www.fitit.lt', 'Užklausos tipas: Forma', [
            { name: 'email', value: this.cEmail },
            { name: 'firstname', value: this.cName },
            { name: 'lastname', value: this.cLastname },
            { name: 'message', value: this.cDescription + '\n' + (this.cConsultation === true ? 'Konsultacija reikalinga' : 'Konsultacijos nereikia') },
            { name: 'phone', value: this.cPhone },
            { name: 'salutation', value: 'Užklausos tipas: Forma' },
        ]);

        this.thanks = true;

        this.sendOLD();
    }
}
